module.exports = __webpack_public_path__ + "img/amenity-logo-mobile.cf1d0a08.svg";